import { type Price } from '@/infra/services/catalog/model';
import { type Optional } from '@/infra/services/catalog/service/model';

const getAdditionalPriceFromOptionals = (optionals: Optional[]): Price =>
  optionals.reduce(
    (previous, current) => ({
      to: previous.to + current.price.to,
      from:
        previous.from +
        (current.price.from && current.price.from > 0
          ? current.price.from
          : current.price.to),
    }),
    { to: 0, from: 0 }
  );

export default getAdditionalPriceFromOptionals;
